import style from './style.module.scss';


function PostOption({isOpen, onDelete}) {
  return (
    <div className={(isOpen? style.open : style.close)}>
        <div className={style.optionContainer}>
            <div className={style.option} onClick={() => onDelete()}>
                Delete Mark
            </div>
        </div>
    </div>
  )
}

export default PostOption;